import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    fallbackLng: "en",
    whitelist: ["en", "fr"],
    supportedLngs: ["en", "fr"],
    lowerCaseLng: true,
    defaultNS: "common",
    fallbackNS: "common",
    ns: [
      "bank",
      "common",
      "expire",
      "forgot",
      "form",
      "landing",
      "links",
      "login",
      "notFound",
      "palette",
      "submit",
    ],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    cache: [],
    detection: {
      // order and from where user language should be detected
      order: ["path"],

      // keys or params to lookup language from
      lookupFromPathIndex: 0,
    },
  });

export default i18n;
